"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSingletonFunction = void 0;
function makeSingletonFunction(makeObject) {
    const singletons = [];
    return () => {
        if (singletons.length === 0) {
            singletons.push(makeObject());
        }
        return singletons[0];
    };
}
exports.makeSingletonFunction = makeSingletonFunction;
//# sourceMappingURL=SingletonUtils.js.map